import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/styles.scss';

const Layout = ({children, data}) => {
	return (
		<div className={'root'}>
			<Helmet
				title={data.site.siteMetadata.title}
				meta={[
					{name: 'description', content: 'Sample'},
					{name: 'keywords', content: 'sample, something'},
				]}
				bodyAttributes={{className: 'page'}}
			/>
			<Header />
			{children()}
			<Footer/>
		</div>
	);
};

export default Layout;

Layout.propTypes = {
	children: PropTypes.func,
};

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx